var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f16 c-1 bold df-ai-c",class:_vm.className},[_c('span',{staticClass:"line"}),_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }